// extracted by mini-css-extract-plugin
export var active = "_tn-1";
export var circle = "_tn-0";
export var completed = "_tn-2";
export var connector = "_tn-4";
export var connectorCompleted = "_tn-7";
export var connectorSpacer = "_tn-5";
export var iconStrokeOverride = "_tn-8";
export var labelContainer = "_tn-6";
export var pending = "_tn-3";